import React from "react";
import { vehicleFotoUrl } from "@/lib/api";
import CarPlaceholderSvg from "@/components/CarPlaceholderSvg";

// Sprint UI-GLOBALE — miniatura della copertina nelle liste; senza foto, segnaposto neutro.
export default function CopertinaThumb({ vehicleId, coverId }) {
  return (
    <div className="h-12 w-16 rounded-md overflow-hidden border border-slate-200 bg-slate-100 shrink-0" data-testid={`thumb-${vehicleId || "none"}`}>
      {vehicleId && coverId ? (
        <img src={vehicleFotoUrl(vehicleId, coverId)} alt="" loading="lazy" draggable={false} className="h-full w-full object-cover" />
      ) : (
        <CarPlaceholderSvg className="h-full w-full" />
      )}
    </div>
  );
}

// Copertina = prima foto della categoria VEICOLO per ordine (stessa regola dell'intestazione veicolo).
export const copertinaId = (foto) => {
  const arr = (foto || []).filter((f) => (f.categoria || "VEICOLO") === "VEICOLO");
  arr.sort((a, b) => (a.ord || 0) - (b.ord || 0));
  return arr[0]?.id || null;
};
